import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import HorizontalStoryCard from "../horizontal-story-card";
import CommonStoryCard from "../common-story-card";
import LoadMoreStories from "../../rows/Load-more-stories";
import Trending from "../trending";
import getStoriesByCollection from "../../../utils";
import "./common-list-page.m.css";

const CommonListPage = ({ data = {}, hideAuthorWithTime = false }) => {
  const trendingStories = getStoriesByCollection(get(data, ["trendingCollection", "collection"], {}));
  return (
    <div styleName="wrapper">
      {data.stories.length > 0 ? (
        <div>
          <div className="desktop-only">
            {data.stories.map(story => (
              <HorizontalStoryCard story={story} key={story.id} boxPadding={false} showSection increaseFontSize />
            ))}
          </div>
          <div className="mobile-only" styleName="card-padding">
            {data.stories.map(story => (
              <CommonStoryCard story={story} key={story.id} showSection />
            ))}
          </div>
          {data.total > 19 && <LoadMoreStories {...data} showSection boxPadding={false} />}
        </div>
      ) : (
        <div>No Results Found</div>
      )}
      <div className="desktop-only">
        <Trending
          stories={trendingStories}
          collection={get(data, ["trendingCollection", "collection"], {})}
          hideAuthorWithTime={hideAuthorWithTime}
        />
      </div>
    </div>
  );
};

CommonListPage.propTypes = {
  data: PropTypes.shape({
    stories: PropTypes.array
  }),
  hideAuthorWithTime: PropTypes.bool
};
export default CommonListPage;
